import { createActionGroup, props } from '@ngrx/store';

import { DpRelatedParts } from '@app/core/types/view/dp-products-details.interface';

export const ProductRelatedPartsActions = createActionGroup({
  source: '[Product Related Parts]',
  events: {
    loadConfig: props<{ code: string }>(),
    loadConfigSuccess: props<{ relatedParts: DpRelatedParts[] }>(),
    setActiveTab: props<{ code: string }>(),
    changeCurrentPage: props<{ currentPage: number }>()
  }
});
